/**
 * GraphQL mutation for deleting an ABR filter.
 * Expects 204 No Content from the backend.
 */

import { gql } from '@apollo/client';

export const DELETE_ABR_FILTER = gql`
  mutation DeleteAbrFilter($input: DeleteAbrFilterInput!) {
    deleteAbrFilter(input: $input)
  }
`;
